export default "__VITE_ASSET__BSJTo1Yj__"